import { useMemo } from "react";
import type { Theme } from "../shared/types";

type ThemeVariants = {
  [key in Theme]: {
    primaryBg: string;
    secondaryBg: string;
    primaryButton: string;
    accent1: string;
    accent2: string;
    border?: string;
  };
};

function useTheme(theme: Theme = "default") {
  const themeVariants: ThemeVariants = useMemo(
    () => ({
      default: {
        primaryBg: "bg-primary text-white",
        secondaryBg: "bg-gray-100",
        primaryButton: "bg-black hover:bg-rapidblue text-white",
        accent1: "text-primary",
        accent2: "group-data-[checked]:border-primary",
      },
      plat: {
        primaryBg: "bg-platinum text-black",
        secondaryBg: "bg-gray-200",
        primaryButton: "bg-gradient-to-b from-[#ffffff] to-[#999999] hover:from-[#999999] hover:to-[#999999] text-black",
        accent1: "text-platinum",
        accent2: "group-data-[checked]:border-platinum",
      },
      uhpw: {
        primaryBg: "bg-rose",
        secondaryBg: "bg-obcontent",
        primaryButton: "bg-rose hover:bg-obcontent text-black",
        accent1: "text-rose",
        accent2: "group-data-[checked]:border-rose",
      },
      bm: {
        primaryBg: "bg-bgreen",
        secondaryBg: "bg-obcontent",
        primaryButton: "bg-bgreen hover:bg-bgreen text-black",
        accent1: "text-bgreen",
        accent2: "group-data-[checked]:border-bgreen",
      },
      ttr: {
        primaryBg:
          "bg-gradient-to-r from-summitdarkblue to-summitltblue text-white",
        secondaryBg: "bg-summityellow ",
        primaryButton: "bg-summitgreen text-black",
        accent1: "text-summitgreen stroke-2",
        accent2: "group-data-[checked]:border-summitltblue text-summitltblue",
        border: "border-gray-400 border-2",
      },
      rpm: {
        primaryBg: 'bg-black shadow-bm',
        secondaryBg: 'bg-obcontent',
        primaryButton: 'bg-rpmdark hover:bg-rpm-light text-black',
        accent1: 'text-black',
        accent2: 'group-data-[checked]:border-black',
        payInFullDisclaimer: 'border-rpmdark bg-rpm-light'
      },
    }),
    []
  );

  return themeVariants[theme] || themeVariants["default"];
}

export default useTheme;
